module.exports = __webpack_public_path__ + "static/media/Sprinta2017.b1bf35c6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/FontIcon/fonts/Sprinta2017.ttf
// module id = 497
// module chunks = 0 1 2 3 4 6 7 8 9 10 15 17 22 24